'use client';

import React, { useState, useRef } from 'react';
import { Volume2, VolumeX, Play } from 'lucide-react';

export default function Hero() {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section className="relative w-full overflow-hidden bg-black select-none">
      {/* Full-bleed Edge-to-Edge Hero Video with Complete 16:9 Frame */}
      <div className="relative w-full aspect-[16/9] max-h-[calc(100vh-3.5rem)] bg-black flex items-center justify-center">
        <video
          ref={videoRef}
          src="/videos/hero_commercial.mp4"
          poster="/videos/hero_commercial_poster.jpg"
          autoPlay
          loop
          muted={isMuted}
          playsInline
          onClick={togglePlay}
          className="w-full h-full object-cover object-center cursor-pointer block"
        />

        {/* Ambient Subtle Vignette */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />

        {/* Floating Audio Controller in bottom right */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleMute();
          }}
          title={isMuted ? 'Click to Unmute Sound' : 'Mute Sound'}
          className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8 z-30 p-3 sm:p-3.5 rounded-full bg-black/60 hover:bg-black/85 backdrop-blur-md border border-white/20 hover:border-[#EAA838] text-white hover:text-[#F7BF54] transition-all shadow-2xl cursor-pointer group"
        >
          {isMuted ? (
            <VolumeX className="w-5 h-5 text-white/80 group-hover:text-white" />
          ) : (
            <Volume2 className="w-5 h-5 text-[#F7BF54] animate-pulse" />
          )}
        </button>

        {/* Center Play Indicator when Paused */}
        {!isPlaying && (
          <div
            onClick={togglePlay}
            className="absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-[2px] cursor-pointer z-20"
          >
            <div className="w-20 h-20 rounded-full bg-[#EAA838] hover:bg-[#F7BF54] text-[#0F382A] flex items-center justify-center shadow-2xl transition-transform hover:scale-110">
              <Play className="w-8 h-8 fill-current ml-1" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}


